registerComponent("pages/products-list", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * Duas coisas: o carrossel de cartões de cada categoria e o menu interno que
 * gruda no topo.
 *
 * ── O carrossel ────────────────────────────────────────────────────────────
 *
 * O slick de 2020 (`mobileFirst: true`, `slidesToShow: 1`, `2` a partir de
 * `breakpoint: 600`, `"unslick"` a partir de `breakpoint: 1024`,
 * `infinite: false`) vira um `Asa.trilho` por `.wrap-cards`. O degrau mora no
 * `_products-list.less` e o trilho o lê de lá: nenhum `matchMedia` aqui.
 *
 * ⚠️ O `if (Is.mobile.ANY())` que ENVOLVIA tudo isso NÃO tem substituto, e é a
 * mudança de comportamento desta página. `Is.mobile.ANY()` lê o user agent, não
 * a largura: num navegador de mesa — inclusive o headless que capturou o
 * baseline — ele é `false` em QUALQUER largura, então em 390 o baseline mostra a
 * grade empilhada (15.969 px de altura), não o carrossel. Quem via o carrossel
 * era o telefone de verdade. A regra do programa é largura no CSS e zero classe
 * de UA, e perder o carrossel do telefone seria perder funcionalidade: o
 * trilho fica, e a divergência contra o recorte de 390 está declarada no
 * relatório e em "Correções ao plano".
 *
 * ── O menu que gruda ───────────────────────────────────────────────────────
 *
 * Era o bloco `body.menu-fixed` do `legacy-main.js`, global para quem tivesse
 * `.fixed-header`; hoje é `Asa.legado.submenuAncorado`, que prende o menu e
 * cuida da âncora `#categoria` — a mesma peça que `pages/product-internal` usa
 * para as âncoras dos blocos do fundo.
 *
 * A URL de categoria, `asset-management/renda-fixa/`, é 301 para
 * `asset-management#renda-fixa`.
 */

component.querySelectorAll('.wrap-cards').forEach(function (lista) {
    // O `if (totalItens > 1)` de 2020: categoria com um fundo só nunca virou
    // carrossel — e é a mesma condição com que o Blade decide renderizar o
    // `blocks/slider-controls`.
    if (lista.querySelectorAll('[data-component-name="blocks/card-product"]').length < 2) {
        return;
    }

    const categoria = lista.closest('.product-type');

    Asa.trilho(lista, Object.assign(
        { itens: '[data-component-name="blocks/card-product"]', passo: 'pagina' },
        Asa.controlesDoTrilho(categoria && categoria.querySelector('[data-component-name="blocks/slider-controls"]')),
    ));
});

Asa.legado.submenuAncorado(component, { secoes: '.product-type[id]' });

});
